  jQuery(function ($) {
    const variantPriceContainer = $('#variant-unit-price');
    const variants = JSON.parse(variantPriceContainer.attr('data-variants'));

    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function updatePriceDisplay(variant) {
      if (!variant) return;

      let weight = variant.weight;
      let weightUnit = document.querySelector('[data-weight-unit]').getAttribute('data-weight-unit');

      // Convert oz to grams if necessary
      if (weightUnit == 'oz') {
        weight = (weight / 28.3495).toFixed(2); // Convert oz to grams
        weightUnit = 'ml'; // Change unit to grams
      }

      const price = (variant.price / 100.0).toFixed(2);
      const unitPrice = weight > 0 ? (price / weight).toFixed(2) : 'N/A';

      const pricePerUnitHtml =
        weight > 0 ? `Rs. ${unitPrice} / ${weightUnit}` : '';

      $('#price-per-unit').html(pricePerUnitHtml);
    }

    function findVariantById(variantId) {
      return variants.find((v) => v.id === parseInt(variantId));
    }

    function findVariantByOptions() {
      const selectedOptions = [];
      $('input[type="radio"]:checked').each(function () {
        selectedOptions.push($(this).val());
      });

      return variants.find((variant) => {
        return (
          (variant.option1 === selectedOptions[0] || !selectedOptions[0]) &&
          (variant.option2 === selectedOptions[1] || !selectedOptions[1]) &&
          (variant.option3 === selectedOptions[2] || !selectedOptions[2]) &&
          (variant.option4 === selectedOptions[3] || !selectedOptions[3]) &&
          (variant.option5 === selectedOptions[4] || !selectedOptions[4])
        );
      });
    }

    function updateUnitPrice() {
      const selectedVariant = findVariantByOptions();
      if (selectedVariant) {
        updatePriceDisplay(selectedVariant);
      }
    }

    // Initial load - check URL for variant
    const variantId = getUrlParameter('variant');
    if (variantId) {
      const variant = findVariantById(variantId);
      updatePriceDisplay(variant);
    } else {
      // No variant in URL, use selected options
      updateUnitPrice();
    }

    // Listen for changes on any radio button
    $(document).on('change', 'input[type="radio"]', updateUnitPrice);

    // Listen for variant changes triggered by the theme
    $(document).on('variant:changed', updateUnitPrice);
  });